export class ShipTo {
  public constructor() {
    this.Company = "";
    this.Cust_Num = "";
    this.Cust_Seq = 0;
    this.Address1 = "";
    this.Address2 = "";
    this.City = "";
    this.State = "";
    this.ZipCode = "";
    this.Country = "";
    this.Email = "";
    this.Phone = "";
  }

  public Company: string;
  public Cust_Num: string;
  public Cust_Seq: number;
  public Address1: string;
  public Address2: string;
  public City: string;
  public State: string;
  public ZipCode: string;
  public Country: string;
  public Email: string;
  public Phone: string;
}
